module.exports = {"title":"Eine letzte Sache..","hint":"Bitte klicken Sie auf die unten aufgeführte Kontrollkästchen"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/recaptcha.json
// module id = 510
// module chunks = 248 1671